/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

import { IRoom } from '../types/room';
import { UserInformation } from '../types/user';

export const checkDisableDiscussion = (
  userIsInDiscussion: boolean,
  serviceSelected: IRoom,
  currentUserInfo: UserInformation,
  isManagerOrSupervisor: boolean
) => {
  if (isManagerOrSupervisor) {
    return false;
  }

  if (userIsInDiscussion) {
    return false;
  }

  if (serviceSelected.servedBy?._id === currentUserInfo._id) {
    return false;
  }

  return true;
};

export const checkDisableTransfer = (
  serviceSelected: IRoom,
  currentUserInfo: UserInformation,
  isManagerOrSupervisor: boolean
) => {
  if (serviceSelected?.closedBy) {
    return true;
  }

  if (isManagerOrSupervisor) {
    return false;
  }

  if (serviceSelected.servedBy?._id === currentUserInfo._id) {
    return false;
  }

  return true;
};

export const checkDisableTags = (
  serviceSelected: IRoom,
  currentUserInfo: UserInformation,
  isManagerOrSupervisor: boolean
) => {
  if (isManagerOrSupervisor) {
    return false;
  }

  if (serviceSelected.servedBy?._id === currentUserInfo._id) {
    return false;
  }

  return true;
};
